import { useTranslation } from 'react-i18next';
import { MarketAccessory, MarketActionCard, MarketRow } from '@market/react';
import GooglePayLogo from 'images/icons/google-pay.svg';

const GooglePay = (props) => {
  const { t } = useTranslation();
  const { submitting, tokenize } = props;

  return (
    <MarketActionCard
      {...(submitting && { disabled: true })}
      onClick={tokenize}
      style={{ margin: '20px 0px' }}
    >
      <MarketRow variant="drill">
        <MarketAccessory
          slot="leading-accessory"
          style={{ width: '60px', height: '40px' }}
        >
          <img src={GooglePayLogo} style={{ width: '95%' }} />
        </MarketAccessory>
        <label slot="label">{t('checkout.payment.payWithGooglePay')}</label>
      </MarketRow>
    </MarketActionCard>
  );
};

export default GooglePay;
